import * as types from "../../../../constants/actionTypes";

export const toggleShowAssignQuotePopup = (showAssignQuotePopup, copyJob = null) => ({
  type: types.TOGGLE_SHOW_ASSIGN_QUOTE_POPUP,
  payload: {showAssignQuotePopup, copyJob}
});

export const setAssignQuotePopupSearchText = (assignQuotePopupSearchText) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT,
  payload: {assignQuotePopupSearchText}
});

export const setAssignQuotePopupEmployee = (assignQuotePopupEmployee) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_EMPLOYEE,
  payload: {assignQuotePopupEmployee}
});

export const setAssignQuotePopupCustomer = (assignQuotePopupCustomer) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_CUSTOMER,
  payload: {assignQuotePopupCustomer}
});

export const setAssignQuotePopupSuccessText = (assignQuotePopupSuccessText) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT,
  payload: {assignQuotePopupSuccessText}
});

export const setAssignQuotePopupUserInfo = (userInfo) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_USER_INFO,
  payload: {userInfo}
});
export const setAssignQuotePopupUserInfoErrors = (userInfoErrors) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_USER_INFO_ERRORS,
  payload: {userInfoErrors}
});
